import { Component } from "@angular/core";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../core/services/auth.service";

@Component({
  selector: "app-free-subscription",
  templateUrl: "./free-subscription.component.html",
  styleUrls: ["./free-subscription.component.scss"],
})
export class FreeSubscriptionComponent {
  readonly appStoreUrl = environment.appStoreUrl;

  constructor(private authService: AuthService) {}

  openAppStore(): void {
    window.open(this.appStoreUrl, "_blank", "noopener,noreferrer");
  }

  logout(): void {
    this.authService.logout();
  }
}
